import { useEffect, useState } from 'react';
import WealthPackages from './WealthPackages';
import { fetchData, textWithIcon, styles } from './Helpers';
import { fileKeyImg, vectorImg, resolveImage } from "../../images/ImageResolver";

function transformData(data){
  return data.map(item => {
    return {
      ...item,
      measureName: item.measureName + "," + item.sector + "," + item.measureCode + "," + item.measureType
    }
  });
}

export default function Measures() {
  const [wealth, setWealth] = useState(false);
  const [fullData, setFullData] = useState([]);
  const [searchData, setSearchData] = useState([]);
  const [loading, setLoading] = useState(true);

  function searchEvent(val) {    
    setSearchData(fullData.filter(item => item.measureName.toLowerCase().includes(val.toLowerCase())));
  }

  useEffect(() => {
    fetchData("Est_List_of_Measures").then((res) => {
      setFullData(transformData(res));
      setLoading(false);
    });
  }, []);

  useEffect(() => {
    const grid = document.getElementById('grid');
    const columns = [
      { name: 'ITEM', field: 'measureName', width: 4, scalable: true, binding: cellWithMultipleLines },
      { name: 'PUBLIC', field: 'public', width: 1.5, scalable: true, headerBinding: headerWithLink.bind(null, "Non Professional", "free"), binding: textWithIcon, styles: styles },
      { name: 'PRIVATE', field: 'private', width: 1.5, scalable: true, headerBinding: headerWithLink.bind(null, "Non Professional", "private"), binding: textWithIcon },
      { name: 'PROFESSIONAL', field: 'professional', width: 1.5, scalable: true, headerBinding: headerWithLink.bind(null, "Private", "professional"), binding: textWithIcon }
    ];

    function cellWithMultipleLines(e) {
      let colors = {
        "Airlines": "#FFD333",
        "Banking & Investment Services": "#FF7333",
        "Energy": "#2DD6DA",
        "Generic": "#806400",
        "Insurance": "#A683D7",
        "Mining": "#007678",
        "Real Estate": "#246B3E",
        "Retail": "#B63243",
        "Telecommunication": "#334BFF",
        "Media": "#18DDA3",
        "Technology": "#A683D7"
      };
      let cell = e.cell;
      let content = cell.getContent();
      if (!content) {
        let rowData = e.data.split(",");
        content = document.createElement("div");
        // content.style.textAlign = "center";
        content.style.whiteSpace = "pre-line";
        let firstLine = document.createElement("button");
        let firstLineText = document.createElement("span");
        firstLine.style.fontWeight = "600";
        firstLine.style.color = "#0f1e8a";
        firstLine.style.backgroundColor = "transparent";
        firstLine.style.border = "none";
        firstLine.style.margin = "0px";
        firstLine.style.padding = "0px";
        firstLine.style.fontSize = "14px";
        firstLine.style.cursor = "pointer";
        firstLine.style.marginLeft = "25px";
        firstLineText.textContent = rowData[0];
        firstLine.appendChild(firstLineText);
        content._firstLine = firstLine;
        content.appendChild(firstLine);
        content.appendChild(document.createElement("br"));

        let secondLine = document.createElement("ef-pill");
        secondLine.style.fontWeight = "400";
        secondLine.style.backgroundColor = colors[rowData[1]] || "#999999";
        secondLine.style.color = "#ffffff";
        secondLine.style.border = "none";
        secondLine.style.padding = "12px 15px";
        secondLine.style.margin = "10px 25px";
        secondLine.style.borderRadius = "4px";
        secondLine.style.fontSize = "14px";
        content._secondLine = secondLine;
        content.appendChild(secondLine);
        content._secondLine.textContent = rowData[1];

        let secondLine2 = document.createElement("ef-pill");
        let secondLine22 = document.createElement("span");
        let secondLine2Icon = document.createElement("img");
        secondLine2Icon.src = fileKeyImg;
        secondLine2Icon.style.marginRight = "5px";
        secondLine2Icon.style.marginTop = "5px";
        secondLine22._secondLine2Icon = secondLine2Icon;
        secondLine22.appendChild(secondLine2Icon);
        secondLine2.style.fontWeight = "400";
        secondLine2.style.backgroundColor = "transparent";
        secondLine2.style.color = "#999999";
        secondLine2.style.border = "none";
        secondLine22.textContent = rowData[2];
        secondLine22.style.fontSize = "14px";
        secondLine22.style.display = "inline-flex";
        secondLine22.style.verticalAlign = "super";
        secondLine2.appendChild(secondLine2Icon);
        secondLine2.appendChild(secondLine22);
        content._secondLine2 = secondLine2;
        content.appendChild(secondLine2);

        let secondLine3 = document.createElement("ef-pill");
        let secondLine33 = document.createElement("span");
        let secondLine3Icon = document.createElement("img");
        secondLine3Icon.src = vectorImg;
        secondLine3Icon.style.marginRight = "5px";
        secondLine3Icon.style.marginTop = "5px";
        secondLine33._secondLine3Icon = secondLine3Icon;
        secondLine33.appendChild(secondLine3Icon);
        secondLine3.style.fontWeight = "400";
        secondLine3.style.backgroundColor = "transparent";
        secondLine3.style.color = "#999999";
        secondLine3.style.border = "none";
        secondLine33.textContent = rowData[3];
        secondLine33.style.fontSize = "14px";
        secondLine33.style.display = "inline-flex";
        secondLine33.style.verticalAlign = "text-bottom";
        secondLine3.appendChild(secondLine3Icon);
        secondLine3.appendChild(secondLine33);
        content._secondLine3 = secondLine3;
        content.appendChild(secondLine3);
      }
      cell.setContent(content);
    }

    function headerWithLink(text, i, e) {
      let cell = e.cell;
      let content = cell.getContent();
      if(!content || !content._myHeaderWithLink) {
        content = document.createElement("div");
        content._myHeaderWithLink = true;
        let span = content._span = document.createElement("span");
        span.style.marginRight = "5px";
        let link = content._link = document.createElement("ef-icon");
        link.icon = "link";
        link.style.color = "#0f1e8a";
        content.addEventListener("click", function(arg) {
          arg.stopPropagation();
          setWealth(true);
        });
        let image = content._span1 = document.createElement("img");
        image.style.position = "absolute";
        image.style.top = "10px";
        image.style.right = "5px";
        image.style.width = "38px";
        image.src = resolveImage(i);
        let span2 = content._span2 = document.createElement("span");
        span2.style.display = "block";
        span2.style.fontWeight = 400;
        content.appendChild(span);
        content.appendChild(link);
        content.appendChild(span2);
        content.appendChild(image);
      }

      content._span.textContent = e.columnDef.getName();
      content._span2.textContent = text;
      cell.setContent(content);
    };

    if(!wealth){
      grid.config = {
        rowHeight: 90,
        headerRowHeight: 60,
        columns: columns,
        dataModel: {
          data: searchData.length > 0 ? searchData : fullData,
        },
        sorting: {
          sortableColumns: false,
          initialSort: {
              colIndex: 0, // Column index`
              sortOrder: "a"
          }
        },
      };
    }

  }, [fullData, searchData, wealth]);

  return (
    <div className='main-div'>
      <ef-loader class="loader" hidden={!loading}></ef-loader>
      {wealth && (
        <div>
          <ef-button className="back-button" icon="back" onClick={() => setWealth(false)}>Back</ef-button>
          <WealthPackages />
        </div>
      )}
      {!wealth && (
        <div>
          <h4>Measures</h4>
          <ef-layout flex style={{ marginTop: '20px' }}>
            <ef-layout>
              <input
                className='search-field'
                type="text"
                placeholder="Type to search..."
                onChange={(e) => searchEvent(e.target.value)}
              />
            </ef-layout>
          </ef-layout>
          <efx-grid id="grid" className="entity-grid"></efx-grid>
        </div>
      )}
    </div>
  );
}